import Vue from 'vue'

export const $window = new Vue({
  data: {
    width: window.innerWidth,
    height: window.innerHeight,
    pageYOffset: 0
  },
  computed: {
  	/* 
  		Sidebar offsetTop caluclation
  		82 is height of navbar between 769px && 1215px
  		66 is height of navbar from 768px down
      34 is height of mobile filters bar (< 1216px)
  	*/
  	sidebarYOffset() {
  		let pixels = 0
		  if (this.width > 1215) {
        pixels = 0
      } else if (this.width >= 769 && this.pageYOffset < 82) {
        pixels = 82 - this.pageYOffset + 34
      } else if (this.width < 769 && this.pageYOffset < 66) {
        pixels = 66 - this.pageYOffset + 34
      } else {
      	pixels = 34
      }
      return pixels 
  	}
  },
  created() {
    window.addEventListener('scroll', this.calculateYOffset)
    window.addEventListener('resize', this.resize)

  },
  mounted() {

  },
  methods: {
    calculateYOffset() {
      this.pageYOffset = window.pageYOffset
    },
    resize() {
      this.width = window.innerWidth
      this.height = window.innerHeight
    }
  },
  destroyed() {
  	console.log('destroyed')
  }
})
